import React from "react";
import { Link } from "react-router-dom";

const PartyRepresentativeCard = ({ name, image, position, party, state, constituency }) => {
  return (
    <div className="bg-white shadow-md rounded-xl overflow-hidden border border-orange-200 hover:shadow-lg transition transform hover:scale-[1.02]">
      {/* 🇮🇳 Saffron Top Strip */}
      <div className="h-2 bg-orange-500 w-full" />

      {/* 👤 Representative Info */}
      <div className="p-5 flex items-center space-x-4">
        <img
          src={image}
          alt={name}
          className="w-16 h-16 rounded-full object-cover border-4 border-green-600 shadow-sm"
        />
        <div className="flex flex-col">
          <h3 className="text-lg font-bold text-gray-800">{name}</h3>
          <span className="text-sm text-gray-600 italic">
            {position} — <span className="font-semibold text-blue-700">{party}</span>
          </span>
          <span className="text-sm text-gray-500">{constituency}, {state}</span>
        </div>
      </div>
      

      {/* ✅ Action Button Area */}
      <div className="bg-gradient-to-r from-green-100 to-white px-4 py-3 text-right">
        <Link
          to={`/candidate/${name.toLowerCase().replace(/\s+/g, '-')}`}
          className="inline-block text-green-800 font-semibold text-sm hover:underline hover:text-green-900 transition"
        >
          🔍 View Profile →
        </Link>
      </div>
    </div>
  );
};

export default PartyRepresentativeCard;
